import * as Permissions from '@Modules/Permissions';
import { RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupPermissionsRouting(): RouteObject {
    return {
        path: 'permissions',
        children: [
            setupModuleRouting({
                resourcePath: 'groups',
                editFrame: <Permissions.FrameEditGroup />,
                listFrame: <Permissions.FrameListGroup />,
            }),
            setupModuleRouting({
                resourcePath: 'users',
                editFrame: <Permissions.FrameEditUser />,
                listFrame: <Permissions.FrameListUser />,
            }),
            setupModuleRouting({
                resourcePath: 'mandanten',
                editFrame: <Permissions.FrameEditMandant />,
                listFrame: <Permissions.FrameListMandant />,
            }),
            setupModuleRouting({
                resourcePath: 'applications',
                editFrame: <Permissions.FrameEditExternalApplication />,
                listFrame: <Permissions.FrameListExternalApplication />,
            }),
        ],
    };
}
